import CryptoJS from 'crypto-js'

const TokenKey = 'Share-Token'

export function getShareToken(): string {
  return getWithExpiry(TokenKey)
}

export function getShareOrigin(): any {
  const shareOrigin = localStorage.getItem('shareOrigin')
  if (shareOrigin) {
    return JSON.parse(shareOrigin)
  }
  return false
}

export function setShareToken(token: string, expiry: number) {
  // 设置半小时过期时间
  return setWithExpiry(TokenKey, token, expiry)
}

export function removeShareToken() {
  localStorage.removeItem(TokenKey)
  localStorage.removeItem('shareOrigin')
}

// 设置数据并指定过期时间（以毫秒为单位）
function setWithExpiry(key: string, value: string, expiry: number) {
  const item = {
    value: value, // 实际存储的数据
    expiry: expiry // 过期时间
  }
  localStorage.setItem(key, JSON.stringify(item))
  return value
}

// 获取数据并检查是否过期
function getWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key)
  // 如果数据不存在，返回 null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date().getTime()

  // 如果数据已过期，删除数据并返回 null
  if (now > item.expiry) {
    localStorage.removeItem(key)
    return null
  }

  // 返回未过期的数据
  return item.value
}

/**
 * 获得md5加密后的token
 * @returns md5加密token
 */
export function getMd5ShareToken() {
  const token = getShareToken()
  const sToken = JSON.parse(localStorage.getItem(TokenKey) || '{}')
  if (!token) {
    return token
  }
  const tokenInfo = {
    token: token,
    timestamp: sToken?.expiry
  }
  return {
    ...tokenInfo,
    sign: CryptoJS.MD5(JSON.stringify(tokenInfo)).toString()
  }
}

// export function getTokenHeaderInfo() {
//   const tokenInfo = getMd5Token()
//   if (tokenInfo) {
//     return {
//       authorization: tokenInfo.token,
//       timestamp: tokenInfo.timestamp,
//       sign: tokenInfo.sign
//     }
//   }
//   return {
//     authorization: undefined,
//     timestamp: undefined,
//     sign: undefined
//   }
// }

// export function getHeaderInfoByToken(token: string) {
//   const tokenInfo = {
//     token: token,
//     timestamp: new Date().getTime()
//   }
//   return {
//     timestamp: tokenInfo.timestamp,
//     authorization: token,
//     sign: CryptoJS.MD5(JSON.stringify(tokenInfo)).toString()
//   }
// }
